import { render, staticRenderFns } from "./HistoricalTrend.vue?vue&type=template&id=19421910&"
import script from "./HistoricalTrend.vue?vue&type=script&lang=js&"
export * from "./HistoricalTrend.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalTrend.vue?vue&type=style&index=0&id=19421910&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports